import React from 'react';
import { useOrganization } from '../../contexts/OrganizationContext';
import { TopBar } from '../../components/TopBar/TopBar';
import './UserAgreementView.css';

interface UserAgreementViewProps {
  onBack: () => void;
}

/**
 * 用户协议页面
 */
export const UserAgreementView: React.FC<UserAgreementViewProps> = ({ onBack }) => {
  const { organization } = useOrganization();
  const userAgreement = organization?.userAgreement || '';

  return (
    <div className="user-agreement-view">
      <TopBar title="用户协议" showBack onBack={onBack} />
      <div className="user-agreement-content">
        {userAgreement ? (
          <div 
            className="agreement-html" 
            dangerouslySetInnerHTML={{ __html: userAgreement }}
          />
        ) : (
          <div className="agreement-empty">暂无用户协议内容</div>
        )}
      </div>
    </div>
  );
};

